/* @generated */
// prettier-ignore
if (Intl.PluralRules && typeof Intl.PluralRules.__addLocaleData === 'function') {
  Intl.PluralRules.__addLocaleData({
    "data": {
      "cs": {
        "categories": {
          "cardinal": ["one", "few", "many", "other"],
          "ordinal": ["other"]
        },
        "fn": function fn(n, ord) {
          var s = String(n).split('.'),
            i = s[0],
            v0 = !s[1];
          if (ord) return 'other';
          return n == 1 && v0 ? 'one' : i >= 2 && i <= 4 && v0 ? 'few' : !v0 ? 'many' : 'other';
        }
      }
    },
    "availableLocales": ["cs"]
  });
}